export default __webpack_public_path__ + "static/media/page-decoration-8.defcf18b.svg";